/**
 * Rol con el que se comprueban los permisos en pantalla.
 *
 * COMERCIAL tiene de momento los permisos de ADMIN, igual que en el backend
 * (utils/roleUtils allí): sus permisos propios están por definir. Se resuelve en un solo
 * sitio, al guardar el usuario en la sesión, para que el día que se definan baste con
 * quitar esta equivalencia.
 */
export function permissionRole<T extends string | null | undefined>(
  role: T
): T | "ADMIN" {
  return role === "COMERCIAL" ? "ADMIN" : role;
}
